function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.33333 4V9.33333H12V8H8.66667V4H7.33333ZM14.5693 9.122L15.9013 9.228C15.8133 9.79733 15.6673 10.3453 15.4667 10.868L14.2667 10.2647C14.4 9.89733 14.502 9.516 14.5693 9.122ZM12.8707 14.3393L11.9287 13.3773C11.6047 13.6147 11.258 13.8227 10.892 13.9993L11.338 15.2653C11.8853 15.014 12.3987 14.7027 12.8707 14.3393ZM13.688 11.4667C13.4647 11.8307 13.2087 12.1713 12.922 12.4853L13.858 13.4407C14.2467 13.0227 14.5907 12.5633 14.884 12.0687L13.688 11.4667ZM0 8C0 12.418 3.58333 16 8.00267 16C8.72333 16 9.41867 15.896 10.0827 15.7173L9.63933 14.4547C9.11467 14.588 8.568 14.6667 8.00267 14.6667C4.32533 14.6667 1.334 11.676 1.334 8C1.334 4.324 4.32533 1.33333 8.00267 1.33333C9.49267 1.33333 10.8647 1.82933 11.9753 2.65933L10.6087 4.02533L15.2853 4.928L14.382 0.252667L12.926 1.708C11.5687 0.642667 9.86267 0 8.00267 0C3.58333 0 0 3.582 0 8H0ZM15.8487 6.42733H14.4647C14.5733 6.868 14.6387 7.32333 14.6567 7.792L16 7.89933C15.9933 7.396 15.9433 6.90333 15.8487 6.42733Z"
});

function SvgCountdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountdown);
export default __webpack_public_path__ + "static/media/countdown.8adf9b7dc79630d3b36ed9bb29e55e74.svg";
export { ForwardRef as ReactComponent };